import { render } from "./FeaturedWatches.vue?vue&type=template&id=17a647b8"
import script from "./FeaturedWatches.vue?vue&type=script&lang=js"
export * from "./FeaturedWatches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__